module.exports = "fragment ExpenseReload on ExpenseReload {\n  purchaseAmount\n  threshold\n  isEnabled\n  isRequired\n}\n"